module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10242.adf00d9a.jpg";